// extracted by mini-css-extract-plugin
export var compact = "_mu-2";
export var phoneFrame = "_mu-0";
export var phoneScreen = "_mu-1";